import React, { useState } from 'react';
import axios from 'axios';

const Login = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await axios.post('https://courriers.oscep.cd/login.php', { 
                username: username, 
                password: password 
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            if (response.data && response.data.success) {
                onLogin(response.data.user);
            } else {
                setError(response.data.message || "Identifiants invalides");
            }
        } catch (err) {
            console.error("Erreur de connexion:", err);
            setError("Impossible de joindre le serveur. Vérifiez votre connexion.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="card" style={{maxWidth: '400px', margin: '100px auto', padding: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)'}}>
                <h2 style={{textAlign: 'center', color: '#003366'}}>Connexion G-COURRIER</h2>
                <form onSubmit={handleSubmit}>
                    <div style={{marginBottom: '15px'}}>
                        <label style={{display: 'block', marginBottom: '5px'}}>Identifiant</label>
                        <input 
                            type="text" 
                            value={username} 
                            onChange={(e) => setUsername(e.target.value)} 
                            required 
                            disabled={loading}
                            style={{width: '100%', padding: '8px', boxSizing: 'border-box'}}
                        />
                    </div>
                    
                    <div style={{marginBottom: '15px'}}>
                        <label style={{display: 'block', marginBottom: '5px'}}>Mot de passe</label>
                        <input 
                            type="password" 
                            value={password} 
                            onChange={(e) => setPassword(e.target.value)} 
                            required 
                            disabled={loading}
                            style={{width: '100%', padding: '8px', boxSizing: 'border-box'}}
                        />
                    </div>
                    
                    <button 
                        type="submit" 
                        disabled={loading}
                        style={{
                            width: '100%', 
                            padding: '10px', 
                            marginTop: '10px', 
                            backgroundColor: '#003366', 
                            color: 'white', 
                            border: 'none', 
                            borderRadius: '4px',
                            cursor: loading ? 'not-allowed' : 'pointer'
                        }}
                    >
                        {loading ? 'Connexion en cours...' : 'Entrer'}
                    </button>
                </form>
                {error && <p style={{color: 'red', textAlign: 'center', marginTop: '15px', fontWeight: 'bold'}}>{error}</p>}
            </div>
        </div>
    );
};

export default Login;
